'use client';
import React from 'react';

import { IRepositoryCompareEntry } from '@/lib/repositoryCompareApi';
import { Row } from '@/ui/primatives';
import Tag from '@/ui/Tag';
import humanFormat from 'human-format';
import FileChangeCountTags from '@/components/Repository/DiffView/FileChangeCountTags';

const formatCount = (value: number) => {
  return humanFormat(value, { maxDecimals: 'auto' });
};

const AddTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tag pill small variant="success">
    {children}
  </Tag>
);

const RemoveTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tag pill small variant="error">
    {children}
  </Tag>
);

const ModifyTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tag pill small variant="info">
    {children}
  </Tag>
);

const TabularEntryDiffSummary: React.FC<{ entry: IRepositoryCompareEntry }> = ({ entry }) => {
  if (entry.data_type !== 'tabular') {
    return null;
  }

  const summmary = entry?.diff_summary?.tabular;
  const addedRows = summmary?.num_added_rows || 0;
  const removedRows = summmary?.num_removed_rows || 0;
  const rowCountChange = addedRows !== 0 || removedRows !== 0;
  const schemaChange = summmary?.schema_has_changed;
  const hasChanges = schemaChange || rowCountChange;

  if (!hasChanges || entry.status !== 'modified') {
    return null;
  }

  return (
    <div>
      <Row gap={5} alignItems="center">
        {schemaChange && (
          <>
            <ModifyTag>Schema Changed</ModifyTag>
            {!!summmary?.num_added_cols && <AddTag>+{summmary?.num_added_cols} cols</AddTag>}
            {!!summmary?.num_removed_cols && <RemoveTag>-{summmary?.num_removed_cols} cols</RemoveTag>}
          </>
        )}
        {addedRows !== 0 && <AddTag>+{formatCount(addedRows)} rows</AddTag>}
        {removedRows !== 0 && <RemoveTag>-{formatCount(removedRows)} rows</RemoveTag>}
      </Row>
    </div>
  );
};

const Folder = FileChangeCountTags;
const Tabular = TabularEntryDiffSummary;

export { Folder, Tabular };
